import { CsvImportResult } from "../types";
import { fetchApi } from "../../../../lib/fetchApi";
import { createDictionaryApiFactory, mapDictionaryState } from "./dictionaryApiFactory";
import { SelectItemDto } from "../../../../types/SelectItemDto";

export const mapToServiceIndicators = mapDictionaryState;

const serviceIndicatorsApi = createDictionaryApiFactory("serviceIndicators");

export const getServiceIndicators = serviceIndicatorsApi.search;
export const getServiceIndicatorsDetail = serviceIndicatorsApi.getDetail;
export const exportCsvServiceIndicatorsClosed = serviceIndicatorsApi.exportCsv;

export const getServiceIndicatorSelect = async (): Promise<SelectItemDto[]> => {
    const response = await fetchApi.get(`/serviceIndicators/select`) as SelectItemDto[];
    return response;
}

export const uploadServiceIndicatorsCsv = async (file: File): Promise<CsvImportResult> => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await fetchApi.post(
  "/serviceIndicators/uploadCsv",
  formData,
  {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }
) as CsvImportResult;

  return response;
};


